import qs from 'qs';
import urlParse from 'url-parse';
import { inBrowser } from './index';
import _isObject from 'lodash/isObject';

/**
 * 获取url参数
 * @param  {string} name 参数名
 * @return {string} 参数值
 */
export function getUrlParam(name) {
    if (inBrowser) {
        const url = window.location.search.split('#')[0];
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        const res = url.substr(1).match(reg);
        if (res !== null) {
            return decodeURIComponent(res[2]);
        }
    }
    return null;
}

/**
 * 获取url中的query对象 不包括hash中的query
 * @param  {string} url 参数名
 * @return {string} 参数值
 */
export function getUrlQsObject(url) {
    // 没有query则返回空对象
    return urlParse(url || window.location.href, true).query;
}

/**
 * 给一个url加入新query参数
 * @param {String} urlString 一个绝对或相对路径.
 * @param {Object} params 要插入的query键值对象
 * @param {Object | String } baseURL 如果urlString是相对路径 以此参数为base作parse 不传表示无base
 */
export function appendParams(urlString, params, baseUrl = {}) {
    const { origin, pathname, query, hash } = urlParse(urlString, baseUrl, true);
    const newQuery = qs.stringify({
        ...query,
        ...params,
    });
    let url = (origin === 'null' ? '' : origin) + pathname;
    if (newQuery) {
        url += `?${newQuery}`;
    }
    if (hash) {
        url += hash;
    }
    return url;
}

/**
 * 将url中的querystring转换为object
 * @param  {String} url 如：a.com/b?c=d&e 或者 a=b&c=
 * @return {Object}     如：{c:'d',e:''}  或者 {a:'b',c:''}
 */
export function parseQuery(url = window.location.search, emptyValue = '') {
    url = url.split('#')[0];
    const arr = url.split('?');
    const queryString = arr[arr.length - 1];
    const entrys = queryString === url ? [] : queryString.split('&');
    const res = {};
    for (let i = 0; i < entrys.length; i++) {
        const entry = entrys[i];
        const arr1 = entry.split('=');

        if (arr1[0]) {
            res[decodeURIComponent(arr1[0])] = decodeURIComponent(arr1[1] || emptyValue);
        }
    }

    return res;
}

/**
 *
 * @param {String} url
 * @param {Object} params
 *
 * @return {String} url
 */
export function replaceAll(url, params = {}) {
    if (_isObject(params)) {
        let temp = url;
        Object.keys(params).forEach(key => {
            // const reg = new RegExp(`{${key}}`, 'g'); // 之所以不用replaceall，是因为在app的webview里面它不支持这个方法https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
            // temp = temp.replace(reg, params[key]);
            temp = temp.replaceAll(`{${key}}`, params[key]);
        });
        return temp;
    }
    return url;
}

// url的query参数值有特殊字符时，解析错误问题
export function jumpCustomerService(bizUrl, data = {}) {
    const { customerServiceEnv: environment, customerService } = bizUrl;
    const { token: serviceToken, ssecurity, did, memberId: uid } = data;
    const targetUrl = appendParams(customerService, {
        uid,
        ssecurity,
        environment,
        did,
        kpn: 'KUAISHOU.VCMERCHANT.WEB',
        subBiz: 'vcMerchant',
        sidName: 'kuaishou.lbs.merchant',
    });
    console.log('targetUrl=', targetUrl);
    // 为了只打开一个，所以直接指定open的name
    window.open(targetUrl, 'CUSTOMER_SERVICE');
}

// url的query参数值有特殊字符时，解析错误问题
export function jumpCustomerServiceDirect(bizUrl, data = {}, config) {
    const { customerServiceDirectEnv: environment, customerService } = bizUrl;
    const { token: serviceToken, ssecurity, did, memberId: uid } = data;

    const targetUrl = appendParams(customerService, {
        uid,
        ssecurity,
        environment,
        did,
        kpn: 'KUAISHOU.VCMERCHANT.WEB',
        subBiz: 'vcMerchant',
        sidName: 'kuaishou.lbs.merchant',
        targetId: config.targetId,
    });
    console.log('targetUrl=', targetUrl);
    // 为了只打开一个，所以直接指定open的name
    window.open(targetUrl, 'CUSTOMER_SERVICE');
}

/**
 *
 * 替换当前路径
 * @export
 * @param {String} path 原始路径
 * @param {Object} params 要拼接的键值对对象
 * @return {*}
 */
// export function jumpTo(path, params = {}) {
//     if (path) {
//         const newUrl = appendParams(decodeURIComponent(path), params);
//         window.location.href = newUrl;
//     }
// }

/**
 * 拼接url参数
 * @param {*} object 参数对象 {a: 'a'}
 * @param {*} url host https://baidu.com?b=b
 * @returns https://baidu.com?b=b&a=a
 */
export function replaceUrlQuery(object, url) {
    const urlNoQuery = url.split('?')?.[0];
    const urlQuery = url.split('?')?.[1];
    object = { ...parseQuery(urlQuery), ...object };
    const query = Object.keys(object).reduce((str, key) => {
        return `${str}${str ? '&' : ''}${key}=${object[key]}`;
    }, '');
    return `${urlNoQuery}${query ? '?' : ''}${query}`;
}

export function openNewTab(url, targin = '_new') {
    if (!url) {
        return;
    }
    const a = document.createElement('a');
    a.href = url;
    !!targin && (a.target = targin); // 指定在新窗口打开
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
